import { redirect } from 'react-router'

import { configurationsRoutePath, signInRoutePath } from 'config/routePaths'
import { getReturnTo } from 'utils/returnTo'
import { clearSessionData, hasSessionData, loadSessionData } from 'utils/session'

export const publicAuthLoader = ({ request } = {}) => {
  loadSessionData()

  const returnTo = request ? getReturnTo(new URL(request.url).search) : null
  return hasSessionData() ? redirect(returnTo || configurationsRoutePath) : null
}

export const signOutLoader = () => {
  clearSessionData()

  return redirect(signInRoutePath)
}
